/**
 * Tone of the bars — colour intent only. Defaults to `default` (primary
 * surface accent), with `success`/`caution`/`error`/`info` matching the M3
 * palette so the sparkline can carry a quick status read at a glance.
 */
export const SPARKLINE_TONE_DEFAULT = 'default';
export const SPARKLINE_TONE_PRIMARY = 'primary';
export const SPARKLINE_TONE_SUCCESS = 'success';
export const SPARKLINE_TONE_CAUTION = 'caution';
export const SPARKLINE_TONE_ERROR = 'error';
export const SPARKLINE_TONE_INFO = 'info';

export type SparklineTone =
  | typeof SPARKLINE_TONE_DEFAULT
  | typeof SPARKLINE_TONE_PRIMARY
  | typeof SPARKLINE_TONE_SUCCESS
  | typeof SPARKLINE_TONE_CAUTION
  | typeof SPARKLINE_TONE_ERROR
  | typeof SPARKLINE_TONE_INFO;

/**
 * Default minimum bar height as a fraction of the total chart height. Empty
 * (zero-value) bins still render a 1-2px stub so the chart shows the full
 * timeline rather than appearing to have gaps. Pass `minBarFraction={0}` to
 * disable.
 */
export const SPARKLINE_DEFAULT_MIN_BAR_FRACTION = 0.08;

/** Default chart height in pixels. */
export const SPARKLINE_DEFAULT_HEIGHT = 32;

/** Default gap between bars in pixels. */
export const SPARKLINE_DEFAULT_GAP = 2;

/** Default top-corner radius applied to each bar (in pixels). */
export const SPARKLINE_DEFAULT_BAR_RADIUS = 1;
